import React from "react";
import "./Research.css";

const books = [
  { title: "Path to Empowerment", author: "Dr. Nisha Verma", year: 2022 },
  { title: "Rural Innovations in India", author: "Prof. Ajay Kumar", year: 2023 },
];

const articles = [
  {
    title: "Social Impact of Rural Libraries",
    author: "Ritu Sharma",
    status: "AI & Plagiarism Cleared",
  },
  {
    title: "Healthcare Access in Villages",
    author: "Arjun Patel",
    status: "Under Review",
  },
];

const ResearchAndPublications = () => {
  return (
    <div className="research-container">
      <h2>🧠 Research & Publications</h2>

      <section className="research-section">
        <h3>📚 Published Books</h3>
        <ul className="book-list">
          {books.map((book, index) => (
            <li key={index}>
              <strong>{book.title}</strong> by {book.author} ({book.year})
            </li>
          ))}
        </ul>
      </section>

      <section className="research-section">
        <h3>📝 Articles & Research Papers</h3>
        <div className="article-grid">
          {articles.map((article, index) => (
            <div className="article-card" key={index}>
              <h4>{article.title}</h4>
              <p><strong>Author:</strong> {article.author}</p>
              <span className={`badge ${article.status.includes("Cleared") ? "cleared" : "pending"}`}>
                {article.status}
              </span>
            </div>
          ))}
        </div>
      </section>

      <section className="author-profiles">
        <h3>👨‍🎓 Featured Authors</h3>
        <ul>
          <li>🔸 Dr. Nisha Verma – Women Empowerment Expert</li>
          <li>🔸 Prof. Ajay Kumar – Rural Innovation Researcher</li>
          <li>🔸 Ritu Sharma – Community Development Analyst</li>
        </ul>
      </section>

      <div className="submit-btn-container">
        <button className="submit-research-btn">📤 Submit Your Research</button>
      </div>
    </div>
  );
};

export default ResearchAndPublications;
